const addAddressModal = document.querySelectorAll('.add-address-modal');
if (addAddressModal.length > 0) {
  const closeAddAddressesModal = () => {
    document.querySelectorAll('.add-address-modal.is-open-modal').forEach((el) => {
      el.classList.remove('is-open-modal');
      toggleBodyScrollLock(false);
    });
  };

  attachEvent('.address-list__add-btn', 'click', (ev) => {
    const parentElem = ev.target.closest('.cart-preview');
    const modal = parentElem.querySelector('.add-address-modal');
    modal.classList.add('is-open-modal');
    toggleBodyScrollLock(true);
  });

  attachEvent('.close-add-address-modal, .add-address-modal__overlay', 'click', () => {
    closeAddAddressesModal();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAddAddressesModal();
    }
  });

  // Create Address Box
  const createAddressBox = (parent) => {
    const parentEle = parent.closest('.cart-preview');
    if (parentEle) {
      const addressList = parentEle.querySelector('.address-list');
      const allInput = parent.querySelectorAll('input');

      const addressCards = addressList.querySelectorAll('.address-list__item');
      addressCards.forEach((item) => item.classList.remove('is-active'));

      // Input Value
      const addressModalTitle = parentEle.querySelector('.add-address-modal__content .title h4');
      const [addressInputValue, apartmentInputValue, postcodeInputValue, cityInputValue] = [
        '[data-input="address_1"]',
        '[data-input="address_2"]',
        '[data-input="postcode"]',
        '[data-input="city"]',
      ].map((selector) => parent.querySelector(`${selector} input`).value);

      // Store In Box
      const parentDiv = document.createElement('div');
      parentDiv.className = 'address-list__item br-8 text--16 is-active';
      parentDiv.innerHTML = `
        	<div class='title : title--h4'>${addressModalTitle.innerHTML}</div>
        	<div class='address-list__item-infos'>
        		<div class='address-list__item-address_1'>${addressInputValue}</div>
        		<div class='address-list__item-address_2'>${apartmentInputValue}</div>
        		<div class='double-inputs'>
        			<div class='address-list__item-postcode'>${postcodeInputValue}</div>
        			<div class='address-list__item-city'>${cityInputValue}</div>
        		</div>
        		<div class='address-list__item-state'>Slovenija</div>
        	</div>
          <button type='button' class='address-list__item-select-btn' aria-label='select address'></button>
        `;

      addressList.append(parentDiv);
      const formData = {};
      const formAction = parent.querySelector('input#action').value;
      const cardIndex = parent.dataset.cardindex;
      parent.querySelectorAll('input, textarea').forEach((input) => {
        if (input.type === 'checkbox') {
          formData[input.name] = input.checked;
        } else {
          formData[input.name] = input.value.trim();
        }
      });

      const cookieData = getCookie('wc_userData');
      cookieData.shipping = formData;

      setCookie('wc_userData', JSON.stringify(cookieData), 1);
      axiosUpdateUserData(formData, formAction, cardIndex);
      closeAddAddressesModal();
      getShippingCost(postcodeInputValue);
      // eslint-disable-next-line no-return-assign, no-param-reassign
      allInput.forEach((item) => (item.value = ''));
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    const addAddressForm = document.querySelector('.add-address-modal__form');
    const postaInput = addAddressForm.querySelector('[name="posta"]');
    const cityInput = addAddressForm.querySelector('[name="mesto"]');

    const fv = FormValidation.formValidation(addAddressForm, {
      locale: 'sl_SI',
      localization: FormValidation.locales.sl_SI,
      fields: {},
      plugins: {
        message: new FormValidation.plugins.Message({
          container: (field, element) => element.closest('.mod-input'),
        }),
        declarative: new FormValidation.plugins.Declarative({
          html5Input: true,
        }),
        trigger: new FormValidation.plugins.Trigger(),
        submitButton: new FormValidation.plugins.SubmitButton(),
      },
    })
      .on('core.element.validated', (e) => {
        // e.element presents the field element
        // e.valid indicates the field is valid or not

        // Get the field value
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(e.element, '.mod-input');
        FormValidation.utils.classSet(container, { 'is-validation-failed': !e.valid && value === '' });
      })
      .on('core.form.valid', () => {
        createAddressBox(addAddressForm);
      });
    initPostCodeHelper(fv, addAddressForm, true, postaInput, cityInput);
  });
}
